// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3pMR2","title":"Images45_title__CYGEb","images":"Images45_images__2vmUS"};